import React, { useState } from 'react';
import AuditEventCard from './AuditEventCard';
import './AuditTimeline.scss';

/**
 * Audit Timeline Component
 * Displays chronological list of audit events
 */
const AuditTimeline = ({ events = [] }) => {
  const [expandedEvents, setExpandedEvents] = useState(new Set());

  const toggleEvent = (eventId) => {
    setExpandedEvents(prev => {
      const next = new Set(prev);
      if (next.has(eventId)) {
        next.delete(eventId);
      } else {
        next.add(eventId);
      }
      return next;
    });
  };

  if (events.length === 0) {
    return (
      <div className="audit-timeline audit-timeline--empty">
        <p>No activity found for this period.</p>
      </div>
    );
  }

  return (
    <div className="audit-timeline">
      {events.map((event, index) => (
        <AuditEventCard
          key={event._id || index}
          event={event}
          isExpanded={expandedEvents.has(event._id || index)}
          onToggle={() => toggleEvent(event._id || index)}
        />
      ))}
    </div>
  );
};

export default AuditTimeline;
